<script setup>
  import { ref } from 'vue'

  const userLoginForm = ref(false)

  const openUserLoginForm = () => {
    userLoginForm.value = true
  }
  const closeUserLoginForm = () => {
    userLoginForm.value = false
  }
</script>

<template>
  <div class="user-login">
    <div
      class="user-login-toggle cursor-pointer transition-all duration-500 border-l border-white/30 px-6 h-full min-w-14 lg:min-w-20 min-h-12 flex w-auto flex-col relative items-center justify-center"
      @click="openUserLoginForm"
    >
      <AppIcon
        name="UserLogin"
      />
    </div>
    <div
      class="user-login-form-wrapper fixed left-0 w-full h-auto bg-primary z-[100] py-36 transitionb-all duration-500 ease-in-out"
      :class="userLoginForm ? 'top-0' : '-top-[120%]'"
    >
      <div class="mx-auto max-w-screen-2xl px-6 relative">
        <span class="close-icon absolute opacity-80 hover:opecity-100 transition-opacity h-4 w-4 -top-12 right-6 cursor-pointer">
          <AppIcon
            name="Close"
            @click="closeUserLoginForm"
          />
        </span>
      </div>
      <div class="px-6 max-w-screen-2xl mx-auto grid lg:grid-cols-4 py-12">
        <div class="col-span-1">
          <slot
            name="title"
          />
        </div>
        <div class="col-span-3">
          <slot
            name="form"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
  .user-login-toggle {
    svg path {
      @apply transition-all duration-500 fill-white !important;
    }
    &:hover {
      svg path {
        @apply fill-primary !important;
      }
    }
  }
  .js-form-item {
    @apply flex flex-col;
    label {
      @apply text-xs my-2 opacity-70 uppercase;
    }
    input {
      @apply border-b border-b-white bg-primary px-2 py-2 text-sm w-full;
    }
    .description {
      @apply hidden;
    }
  }
  .user-login-form {
    @apply grid lg:grid-cols-2 text-white w-full gap-4;
    #edit-actions {
      @apply mt-4;
      input {
        @apply bg-white text-primary px-4 py-2 rounded-full text-sm cursor-pointer opacity-80 hover:opacity-100;
      }
    }
    .more-links {
      @apply mt-4;
      a {
        @apply text-white underline underline-offset-4;
      }
    }

  }
  .user-login-dashboard-link svg path {
    @apply transition-all duration-500 fill-white !important;
  }

  .header-inner.bg-white {
    .more-links a, .user-login-dashboard-link  {
      @apply text-white !important;
    }
  }
</style>
